import React from 'react';

import { AppSettingsContext, HttpClientContext, AuthContext, PageTitleContext, SnackbarContext, ConfirmContext } from '@dxlm/contexts';

export { useFileUploader } from "./file-uploader";
export { useScreenSize } from "./screen-size";
export { useLoadingManager } from "./loading-manager";
export { useBinaryToggle } from "./useBinaryToggle";

export const useAppSettings = () => React.useContext(AppSettingsContext);
export const useHttpClient = () => React.useContext(HttpClientContext);
export const useAuth = () => React.useContext(AuthContext);
export const usePageTitle = () => React.useContext(PageTitleContext);
export const useSnackbar = () => React.useContext(SnackbarContext);
export const useConfirm = () => React.useContext(ConfirmContext);